import React from 'react';
import { trackMultiAdLink } from '../tracking/event';

const ProPackagesLink = ({
  product_description,
  classBlock,
  context,
  localisations,
}) => {
  return product_description == 'Upgrade (inc Bold Advertising)' ? (
    <p className={`${classBlock}__pro-packages-link`}>
      <span className="pro-packages__question">
        {localisations.need_more_than_one_live_ad}{' '}
      </span>

      <a
        id="mulitAdLink"
        href={`/my-account/pro-products/annual?M_context=${context}`}
        onClick={trackMultiAdLink}
      >
        <strong>{localisations.view_our_multi_ad_packages}</strong>
      </a>
    </p>
  ) : null;
};

export default ProPackagesLink;
